"use strict";

exports.__esModule = true;
exports.Type = exports.StepType = exports.MIN_STEPS = exports.MAX_STEPS = exports.FitMode = exports.DataHook = void 0;
var MAX_STEPS = 7;
exports.MAX_STEPS = MAX_STEPS;
var MIN_STEPS = 2;
exports.MIN_STEPS = MIN_STEPS;
var Type = {
  Circle: 'circle',
  Text: 'text'
};
exports.Type = Type;
var StepType = {
  Normal: 'normal',
  Error: 'error',
  Disabled: 'disabled',
  Completed: 'completed'
};
exports.StepType = StepType;
var FitMode = {
  Compact: 'compact',
  Stretched: 'stretched'
};
exports.FitMode = FitMode;
var DataHook = {
  Step: 'stepper-step',
  StepText: 'stepper-step-text'
};
exports.DataHook = DataHook;
//# sourceMappingURL=constants.js.map